var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProgress = function SvgProgress(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C9.80896 2.15716e-08 11.59 0.446128 13.1854 1.29887C14.7807 2.1516 16.1412 3.38463 17.1462 4.88873C18.1512 6.39282 18.7697 8.12156 18.947 9.92181C19.1243 11.7221 18.8549 13.5383 18.1627 15.2095C17.4704 16.8808 16.3767 18.3555 14.9783 19.5031C13.58 20.6507 11.9202 21.4357 10.146 21.7886C8.37179 22.1415 6.53794 22.0515 4.80687 21.5263C3.0758 21.0012 1.50096 20.0573 0.221828 18.7782L8 11V0Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/progress.d12e9f57.svg";
export { ForwardRef as ReactComponent };